exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "upd-resident-portal {\n  display: block;\n}\n\n  upd-resident-portal .resident-portal-content {\n    text-align: center;\n  }\n\n  upd-resident-portal .resident-portal-subtext {\n    color: #8c8c8d;\n    max-width: 780px;\n    margin: 0 auto;\n  }\n\n  upd-resident-portal a.btn-primary {\n    margin: 50px 0 10px 0;\n  }\n", ""]);

